const config = {
    tileSource: process.env.VUE_APP_GARDEN_MAP_TILE_SOURCE,
    showHelp: !!parseInt(process.env.VUE_APP_SHOW_HELP),
    showMenu: !!parseInt(process.env.VUE_APP_SHOW_MENU)
}

// Where to get the locations
config.exhibit_locations_url = process.env.VUE_APP_CMS_ROOT + '/wp-json/exhibits/v0/locations'

// Where to get the CMSed exhibit data (All Media info etc.)
config.exhibit_data_url = process.env.VUE_APP_CMS_ROOT + '/wp-json/exhibits/v0/exhibits'

// Where to get the CMSed exhibit data (All Media info etc.)
config.items_url = process.env.VUE_APP_CMS_ROOT + '/wp-json/exhibits/v0/items/'

// Base URL for content-managed share data pages
config.share_root = process.env.VUE_APP_CMS_ROOT + '/share'

// API endpoint for share uploads
config.share_upload_endpoint = process.env.VUE_APP_CMS_ROOT + '/wp-json/shares/v0/upload'

// Base URL for uploaded landscape images
config.shared_upload_root = process.env.VUE_APP_CMS_ROOT + '/content/uploads/landscapes'

export default config